import { AdvisorsDashboard } from '../../components/Advisors';

export function Advisors() {
  return <AdvisorsDashboard />;
}

export default Advisors;
